module.exports = __webpack_public_path__ + "img/extreme.0c58208.png";